module.exports = __webpack_public_path__ + "img/案例欣赏banner1920x280px.050e519e.png";